import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Salesforce Update Lead v1 Configuration Validator
 * Validates Salesforce lead update configuration
 */
export const Salesforce_Update_Lead_1_ConfigValidator = z.object({
    connection: requiredString('Salesforce Connection is required'),
    leadId: requiredString('Lead ID is required'),
    requestBody: z
        .record(z.string(), z.any())
        .optional()
        .refine((val) => val === undefined || typeof val === 'object', {
        message: 'Request Body must be a valid object'
    })
});
//# sourceMappingURL=salesforce-update-lead-1.js.map